module.exports = function() {
  return new Worker(__webpack_public_path__ + "cb7c0aa03f2dce31c97d.worker.js");
};